module.exports = __webpack_public_path__ + "static/media/droplet.2ce1d898.svg";